export default "__VITE_ASSET__aeb9bc73__"